import React, { FC } from 'react';
import { ICON_COLLECTION } from 'assets/media/icons';
import Icon from 'common/components/base/icon';
import './Footer.scss';

const Footer: FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer>
            <center>
                <div className="footer">
                    <Icon src={ICON_COLLECTION.IC_CopyRight} className="footer-icon" />
                    <span>{`${currentYear} EYGM Limited. All rights reserved.`}</span>
                </div>
            </center>
        </footer>
    );
};

export default Footer;
